import { render, staticRenderFns } from "./ReviewStats.vue?vue&type=template&id=5c0613db&scoped=true&"
import script from "./ReviewStats.vue?vue&type=script&lang=js&"
export * from "./ReviewStats.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStats.vue?vue&type=style&index=0&id=5c0613db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0613db",
  null
  
)

export default component.exports